import { Link } from "react-router-dom";
import { MapPin, Phone, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { CLINIC } from "@/lib/api";

export const Footer = () => (
    <footer className="relative mt-24 bg-[#0f3b3a] text-teal-50" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-4 lg:px-8">
      <div className="md:col-span-2">
        <div className="inline-block rounded-2xl bg-white px-4 py-2"><Logo small /></div>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-teal-100/80">
          Full-service pediatric dental care for infants, toddlers, teens and special children in Malad West, Mumbai.
          Fun, informative and anxiety-free visits for kids and parents.
        </p>
      </div>
      <div className="space-y-3 text-sm">
        <p className="font-display text-lg font-semibold text-white">Visit us</p>
        <p className="flex gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0" />{CLINIC.address}</p>
        <a href={`tel:${CLINIC.phoneRaw}`} className="flex gap-2 hover:text-white" data-testid="footer-phone-link"><Phone className="h-4 w-4" />{CLINIC.phone}</a>
        <p className="flex gap-2"><Clock className="mt-0.5 h-4 w-4 shrink-0" />Mon–Sat 10 AM–1 PM, 5–9 PM · Sun closed</p>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <p className="font-display text-lg font-semibold text-white">Explore</p>
        <Link to="/book" className="hover:text-white" data-testid="footer-book-link">Book an appointment</Link>
        <Link to="/book?type=online" className="hover:text-white" data-testid="footer-online-link">Online consultation</Link>
        <Link to="/fun-zone" className="hover:text-white" data-testid="footer-funzone-link">Kids Fun Zone</Link>
        <Link to="/blog" className="hover:text-white" data-testid="footer-blog-link">Parent tips</Link>
        <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Clinic admin</Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-teal-100/60">
      © {new Date().getFullYear()} Tooth Buds Pediatric Dental Clinic · Dr. Anuj Shah
    </div>
  </footer>
);
